import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService, IncomeTaxEntity,
  PGASpecifiekeZorgkosten,
  ReiskostenZorgGezinslid
} from "@snelstart-ventures/fiscaal/domain-logic";
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../../gedeelde-componenten/gedeelde-componenten.component";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-reiskosten-zorg-gezinslid',
  templateUrl: './reiskosten-zorg-gezinslid.component.html',
  styleUrls: ['./reiskosten-zorg-gezinslid.component.scss'],
  imports: [
    SharedUiButtonModule,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class ReiskostenZorgGezinslidComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public reiskostenZorgGezinslid = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,private router: Router, private fb: FormBuilder) {
        this.reiskostenZorgGezinslid = this.fb.group({
            pgaReiskostenZorgGezinslid:
                this.fb.array<PGASpecifiekeZorgkosten>([])
        })
    }

    get pgaReiskostenZorgGezinslid(): FormArray {
        return this.reiskostenZorgGezinslid.get('pgaReiskostenZorgGezinslid') as FormArray;
    }

    addRijReiskostenZorgGezinslid(): void {
        this.pgaReiskostenZorgGezinslid.push(this.createReiskostenZorgGezinslidFormGroup()
        )
    }

    verwijderRijReiskostenZorgGezinslid(index: number): void {
        this.pgaReiskostenZorgGezinslid.removeAt(index);
        this.reiskostenZorgGezinslid.updateValueAndValidity()
        this.reiskostenZorgGezinslid.markAsDirty()
        this.saveForm()
    }



    createReiskostenZorgGezinslidFormGroup(kosten?: ReiskostenZorgGezinslid): FormGroup {
        return this.fb.group(({
            omschrijving: kosten ? kosten.omschrijving : undefined,
            aantalBezoeken: kosten ? kosten.aantalBezoeken : undefined,
            afstandRetour: kosten ? kosten.afstandRetour : undefined,
            werkelijkeKostenOV: kosten ? kosten.werkelijkeKostenOV : undefined,
        } as ReiskostenZorgGezinslid));
    }

    public ngOnInit(): void {
      this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.reiskostenZorgGezinslid.dirty;
  }

  private updateForm(): void {
        const reiskostenZorgGezinslidLijst = this.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten?.reiskostenZorgGezinslid || [];
        const formArray = this.reiskostenZorgGezinslid.get('pgaReiskostenZorgGezinslid') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > reiskostenZorgGezinslidLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < reiskostenZorgGezinslidLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(reiskostenZorgGezinslidLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createReiskostenZorgGezinslidFormGroup(reiskostenZorgGezinslidLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaSpecifiekeZorgkosten: {
                        ...this.aangifte.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten,
                        reiskostenZorgGezinslid: this.reiskostenZorgGezinslid.value.pgaReiskostenZorgGezinslid
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
